/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WizardStep = require("./wizard-step");
var Wizard = /*#__PURE__*/function () {
  function Wizard(wizardData, getModel) {
    var _this = this;
    _classCallCheck(this, Wizard);
    this.getModel = getModel;
    this.steps = [];
    this.map = {};
    wizardData.steps.forEach(function (step) {
      var stepObject = new WizardStep(step, function () {
        return _this;
      });
      _this.steps.push(stepObject);
      _this.map[step.name] = stepObject;
    });
    this.welcome = wizardData.welcome;
    this.toolchain = wizardData.toolchain;
    this.forms = wizardData.form;
    this.version = wizardData.version;
  }
  return _createClass(Wizard, [{
    key: "getVersion",
    value: function getVersion() {
      return this.version;
    }
  }, {
    key: "isV1",
    value: function isV1() {
      return this.version === "1";
    }
  }, {
    key: "isV2",
    value: function isV2() {
      return this.version === "2";
    }
  }, {
    key: "getWelcomeOffset",
    value: function getWelcomeOffset() {
      // v2 wizard has welcome in two steps
      return this.isV2() ? 2 : 1;
    }
  }, {
    key: "getStepByName",
    value: function getStepByName(name) {
      return this.map[name];
    }
  }, {
    key: "getStepByIndex",
    value: function getStepByIndex(index) {
      return this.steps[index];
    }
  }, {
    key: "getStepByCapability",
    value: function getStepByCapability(capability) {
      return this.steps.find(function (step) {
        return step.getForm() === capability.label || step._getAdvancedForm() === capability.label;
      });
    }
  }, {
    key: "getStepIndexByName",
    value: function getStepIndexByName(name) {
      var steps = this.getSteps({
        visibleOnly: true
      });
      return steps.findIndex(function (step) {
        return step.getName() === name;
      });
    }
  }, {
    key: "getSteps",
    value: function getSteps() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          visibleOnly: false
        },
        visibleOnly = _ref.visibleOnly;
      if (visibleOnly === true) {
        return this.steps.filter(function (step) {
          return step.isVisible();
        });
      }
      return this.steps;
    }
  }, {
    key: "hasSecretsStep",
    value: function hasSecretsStep() {
      var secretStep = this.steps.find(function (step) {
        return step.isVisible() && step.isSecretsStep();
      });
      return secretStep !== undefined;
    }
  }, {
    key: "getSecretsStepIndex",
    value: function getSecretsStepIndex() {
      return this.steps.findIndex(function (step) {
        return step.isVisible() && step.isSecretsStep();
      });
    }
  }, {
    key: "getStepCount",
    value: function getStepCount() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          visibleOnly: false
        },
        visibleOnly = _ref2.visibleOnly;
      return this.getSteps({
        visibleOnly: visibleOnly
      }).length;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.welcome && this.welcome.description;
    }
  }, {
    key: "getModel",
    value: function getModel() {
      return this.getModel();
    }
  }, {
    key: "showGitAccept",
    value: function showGitAccept() {
      if (this.isV2()) {
        return !!(this.toolchain && this.toolchain.git_accept);
      }
      return !!(this.welcome && this.welcome.git_accept);
    }
  }, {
    key: "getGitAcceptLabel",
    value: function getGitAcceptLabel() {
      if (this.isV2()) {
        return this.toolchain && this.toolchain.git_accept && this.toolchain.git_accept.label;
      }
      return this.welcome && this.welcome.git_accept && this.welcome.git_accept.label;
    }

    // v2-only functions
  }, {
    key: "getWelcomePreReq",
    value: function getWelcomePreReq() {
      return this.welcome && this.welcome.prereq;
    }
  }, {
    key: "getWelcomeDocumentation",
    value: function getWelcomeDocumentation() {
      return this.welcome && this.welcome.documentation;
    }
  }, {
    key: "getWelcomeTemplateRepo",
    value: function getWelcomeTemplateRepo() {
      return this.welcome && this.welcome.template;
    }
  }, {
    key: "getWelcomeTutorial",
    value: function getWelcomeTutorial() {
      return this.welcome && this.welcome.tutorial;
    }
  }, {
    key: "getWelcomeInfo",
    value: function getWelcomeInfo() {
      return this.welcome && this.welcome.info;
    }
  }, {
    key: "getToolchainDescription",
    value: function getToolchainDescription() {
      return this.toolchain && this.toolchain.description;
    }
    // end-of v2-only functions
  }, {
    key: "clearSteps",
    value: function clearSteps() {
      this.steps = [];
    }
  }, {
    key: "handleGitAcceptChange",
    value: function handleGitAcceptChange(value) {
      var updatedCapabilities = [];
      this.steps.forEach(function (step) {
        var cap = step.handleGitAcceptChange(value);
        if (cap) {
          updatedCapabilities.push(cap);
        }
      });
      return updatedCapabilities;
    }
  }, {
    key: "getForms",
    value: function getForms() {
      return this.forms;
    }
  }, {
    key: "showLinkToolchain",
    value: function showLinkToolchain() {
      if (this.isV2()) {
        return this.toolchain && this.toolchain.link_toolchain && this.toolchain.link_toolchain.label;
      }
      return this.welcome && this.welcome.link_toolchain && this.welcome.link_toolchain.enabled;
    }
  }, {
    key: "getLinkToolchain",
    value: function getLinkToolchain() {
      if (this.isV2()) {
        return this.showLinkToolchain() && this.toolchain.link_toolchain;
      }
      return this.showLinkToolchain() && this.welcome.link_toolchain;
    }
  }, {
    key: "handleLinkToolchainLoaded",
    value: function handleLinkToolchainLoaded(toolchain, parameterChangeCallback) {
      var _this2 = this;
      if (this.showLinkToolchain()) {
        // Add the link toolchain to the model so that mustache expressions will work
        var model = this.getModel();
        model.setLinkToolchain(toolchain);

        // Execute the conditions
        this._getLinkConditions().forEach(function (condition) {
          if (_this2._evaluateLinkCondition(condition.condition, toolchain)) {
            (condition.actions || []).forEach(function (action) {
              switch (action.type) {
                case 'copy-parameters':
                  if (action.source && action.target) {
                    var target = model.getByLabel(action.target);
                    var source = _this2._getLinkToolchainService(action.source, target && target.service_id, toolchain);
                    if (source && target && source.parameters) {
                      // Build list of source params
                      var include = action.parameters && action.parameters.include || [];
                      var exclude = action.parameters && action.parameters.exclude || [];
                      var _parameters = {};
                      Object.keys(source.parameters).forEach(function (param) {
                        if (include.length > 0) {
                          // Targetted list of params
                          if (include.includes(param)) {
                            _parameters[param] = source.parameters[param];
                          }
                        } else {
                          // Take all params from the source except excluded
                          if (!exclude.includes(param)) {
                            _parameters[param] = source.parameters[param];
                          }
                        }
                      });
                      if (Object.keys(_parameters).length > 0) {
                        // Update the service or form in the model
                        var changedParams = model.updateToolIntegration(undefined, action.target, _parameters, {
                          keep_service: true,
                          allow_forms: true
                        });

                        // After every action notify the UI of the changed service summary. This may cause conditions/actions in wizard steps
                        // to fire. It is important to do this after every action as subsequent actions may depend on a service that is added
                        // by a wizard step condition/action.
                        _this2._fireParameterChangeCallback(target, changedParams, parameterChangeCallback);
                      }
                    }
                  }
                  break;
                case 'set-parameters':
                  if (action.target && action.parameters) {
                    var _target = model.getByLabel(action.target);
                    var _parameters2 = action.parameters;
                    if (Object.keys(_parameters2).length > 0) {
                      // Update the service or form in the model
                      var _changedParams = model.updateToolIntegration(undefined, action.target, _parameters2, {
                        keep_service: true,
                        allow_forms: true
                      });

                      // After every action notify the UI of the changed service summary. This may cause conditions/actions in wizard steps
                      // to fire. It is important to do this after every action as subsequent actions may depend on a service that is added
                      // by a wizard step condition/action.
                      _this2._fireParameterChangeCallback(_target, _changedParams, parameterChangeCallback);
                    }
                  }
                  break;
                default:
                  break;
              }
            });
          }
        });
      }
    }
  }, {
    key: "_fireParameterChangeCallback",
    value: function _fireParameterChangeCallback(capability, changedParams, parameterChangeCallback) {
      if (parameterChangeCallback && changedParams && changedParams.length > 0) {
        var changeSummary = {};
        changedParams.forEach(function (param) {
          return changeSummary[param] = {
            source: "user"
          };
        });
        parameterChangeCallback(capability, changeSummary, {
          wizardStep: this.getStepByCapability(capability)
        });
      }
    }
  }, {
    key: "_getLinkConditions",
    value: function _getLinkConditions() {
      if (this.showLinkToolchain()) {
        if (this.isV2()) {
          return this.toolchain.link_toolchain.conditions || [];
        }
        return this.welcome.link_toolchain.conditions || [];
      }
      return [];
    }
  }, {
    key: "_getLinkToolchainService",
    value: function _getLinkToolchainService(binding, service_id, toolchain) {
      return toolchain.services && toolchain.services.find(function (service) {
        return service.toolchain_binding && service.toolchain_binding.name === binding && (service.service_id === service_id || service_id === null);
      });
    }
  }, {
    key: "_evaluateLinkCondition",
    value: function _evaluateLinkCondition(condition, toolchain) {
      var _this3 = this;
      if (condition.any) {
        // If we find any true condition then success
        return !!condition.any.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this3._evaluateCondition(c, toolchain);
          }
          return c.source_exists && !!_this3._getLinkToolchainService(c.source_exists, null, toolchain);
        });
      } else if (condition.all) {
        // If we find any false condition then fail
        return !condition.all.find(function (c) {
          if (c.any || c.all || c.none) {
            return !_this3._evaluateCondition(c, toolchain);
          }
          return !(c.source_exists && !!_this3._getLinkToolchainService(c.source_exists, null, toolchain));
        });
      } else if (condition.none) {
        // If we find any true condition then fail
        return !condition.none.find(function (c) {
          if (c.any || c.all || c.none) {
            return _this3._evaluateCondition(c, toolchain);
          }
          return c.source_exists && !!_this3._getLinkToolchainService(c.source_exists, null, toolchain);
        });
      }
      return false;
    }
  }]);
}();
module.exports = Wizard;